var render = function (_h,_vm) {
var _obj;
var _c=_vm._c;return (_vm.props.src)?_c('figure',{class:[_vm.$style.icon, ( _obj = {}, _obj[_vm.$style.icon__horizontal] = _vm.props.isHorizontal, _obj )]},[(_vm.props.src)?_c('UiImage',{class:_vm.$style.iconImg,attrs:{"image":{
      publicUrl: _vm.props.src,
      alt: _vm.props.alt || 'Advantage of the Robomow'
    }}}):_vm._e(),_vm._v(" "),_c('figcaption',{class:['p3', _vm.$style.iconCapiton]},[_vm._v("\n    "+_vm._s(_vm.props.title)+"\n  ")])],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }